import React from 'react'
import { Brand, User } from '../../../gql/types'
import { Header } from '../components/Header'
import { Products } from '../../Products'

interface IProps {
  user: User
  brand: Brand
}

export const BrandProducts = ({ user, brand }: IProps) => {
  return (
    <div>
      <Header brand={brand} />

      <Products user={user} />
    </div>
  )
}
